import { Component, OnInit, Input } from '@angular/core';
import { Transition, StateService } from '@uirouter/angular';
import * as moment from 'moment';
import { Channel } from '../FMAPI/channel';
import { UserPreferenceService } from '../user-preference/user-preference.service';
import { UserPreference } from '../user-preference/user-preference';
import { NotificationService } from '../notification/notification.service';
import { NotificationType } from '../notification/notification-type.enum';

@Component({
  selector: 'app-favorite-edit',
  templateUrl: './favorite-edit.component.html',
  styleUrls: ['./favorite-edit.component.css']
})
export class FavoriteEditComponent implements OnInit {

  constructor(
    private userprefsvc: UserPreferenceService,
    private transition: Transition,
    private state: StateService,
    private notification: NotificationService
  ) { }

  @Input() Channels: Channel[];

  UserPref: UserPreference;
  Fave: UserPreference.Favorite;
  IsNew: boolean;
  Selections: { Channel: Channel, Selected: boolean }[];

  ngOnInit() {
    this.UserPref = this.userprefsvc.Get();
    const idx = Number(this.transition.params().favoriteid);
    const existing = this.UserPref.Favorites[idx];
    this.IsNew = existing == undefined || existing == null

    if (this.IsNew) {
      this.Fave = new UserPreference.Favorite();
      this.Fave.Channels = [];
    } else {
      this.Fave = existing;
    }

    let self = this;
    this.Selections = this.Channels.map(channel => {
      const selected = self.Fave.Channels.map(ch => ch.Code).includes(channel.Code.toString());
      return { Channel: channel, Selected: selected };
    });
  }

  GetSelected() {
    const selecteds = this.Selections.filter(s => s.Selected).map(s => s.Channel);
    return selecteds;
  }

  SelectAll() {
    this.Selections.forEach(item => item.Selected = true);
  }

  DeselectAll() {
    this.Selections.forEach(item => item.Selected = false);
  }

  Delete() {
    if (this.IsNew) {
      this.state.go("show." + this.UserPref.SelectedView);
      return;
    };

    if (this.UserPref.Favorites.length < 2) {
      this.notification.Notify("Cannot delete the last item.", NotificationType.Warning);
      return;
    };

    var idx = this.UserPref.Favorites.indexOf(this.Fave);
    this.UserPref.Favorites.splice(idx, 1);

    if (this.UserPref.SelectedFavorite > this.UserPref.Favorites.length) {
      this.UserPref.SelectedFavorite = 0;
    };

    this.userprefsvc.Set(this.UserPref);

    this.state.go("show." + this.UserPref.SelectedView);
  }

  Update() {
    if (!this.Fave.Code) {
      this.Fave.Code = moment().format("x");
    };

    this.Fave.Channels = this.GetSelected();

    if (this.IsNew) {
      this.UserPref.Favorites.push(this.Fave);
    };

    this.UserPref.SelectedFavorite = this.UserPref.Favorites.indexOf(this.Fave);

    this.userprefsvc.Set(this.UserPref);

    this.state.go("show." + this.UserPref.SelectedView);
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/favorite-edit/favorite-edit.component.ts